import { EmissionItem } from '../api';
import { DecisionCell, DocumentCell, IssuerCell, StatusCell, StringCell } from '../components/EmissionsTable/Cells';
import { EmissionsTableColumn } from '../components/EmissionsTable/types';


export const columns: Partial<Record<keyof EmissionItem, EmissionsTableColumn>> = {
    issuer: {
        field: 'issuer',
        Cell: IssuerCell,
        width: 164,
        mobileWidth: 156,
    },
    status: {
        field: 'status',
        Cell: StatusCell,
        width: 107,
        mobileWidth: 95,
    },
    circulationperiod: {
        field: 'circulationperiod',
        Cell: StringCell,
        width: 126,
        mobileWidth: 98,
    },
    decision: {
        field: 'decision',
        Cell: DecisionCell,
        width: 217,
        mobileWidth: 234,
    },
    result: {
        field: 'result',
        Cell: DocumentCell,
        width: 211,
        mobileWidth: 162,
    },
    repayment: {
        field: 'repayment',
        Cell: DocumentCell,
        width: 207,
        mobileWidth: 155,
    },
};

const emissionsColumnOrder = [
    'issuer',
    'status',
    'circulationperiod',
    'decision',
    'result',
    'repayment',
];

export const emissionsColumns = emissionsColumnOrder.map(column => columns[column]);
